import React, { useState, useEffect } from 'react';

let toggleBookingOverlay = null;

export const BookingOverlay = () => {
	const [isActive, setIsActive] = useState(false);

	// Expose external toggle
	useEffect(() => {
		toggleBookingOverlay = () => setIsActive((prev) => !prev);
		return () => (toggleBookingOverlay = null);
	}, []);

	const closeOverlay = () => setIsActive(false);

	return (
		<div
			className={`overlay js-bookings-overlay${
				isActive ? ' is-active' : ''
			}`}
			role='dialog'
			aria-hidden={!isActive}
			data-lenis-prevent
		>
			<button
				type='button'
				onClick={closeOverlay}
				className='close-btn'
				aria-label='Close'
			/>
		</div>
	);
};

export const toggleOverlay = () => {
	if (typeof window === 'undefined') return;
	if (toggleBookingOverlay) toggleBookingOverlay();
	else console.warn('BookingOverlay not mounted.');
};
